export default "__VITE_ASSET__976ec22a__"